import { connect } from 'react-redux'
import { IStatisticsDispatchProps, IStatisticsProps, FunFacts } from './FunFacts'
import { getSpecificCompanyStatistics, setSelectedCompanyId } from './store/StatisticsActions'
import { getCompanyStatistics, getStatisticsSelectedCompanyId } from './store/StatisticsSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { CompanyId } from '../../services/api.types'

interface IOwnProps {
  companyId: CompanyId
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStatisticsProps => ({
  companyId: ownProps.companyId,
  companyStatistics: getCompanyStatistics(state),
  selectedCompanyId: getStatisticsSelectedCompanyId(state),
})

const mapDispatchToProps: IStatisticsDispatchProps = {
  getSpecificCompanyStatistics,
  setSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(FunFacts)
